import { render, staticRenderFns } from "./roleAuthority.vue?vue&type=template&id=2a9e045a&scoped=true"
import script from "./roleAuthority.vue?vue&type=script&lang=js"
export * from "./roleAuthority.vue?vue&type=script&lang=js"
import style0 from "./roleAuthority.vue?vue&type=style&index=0&id=2a9e045a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e045a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9e045a')) {
      api.createRecord('2a9e045a', component.options)
    } else {
      api.reload('2a9e045a', component.options)
    }
    module.hot.accept("./roleAuthority.vue?vue&type=template&id=2a9e045a&scoped=true", function () {
      api.rerender('2a9e045a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authorityManagement/roleAuthority.vue"
export default component.exports